<!--
 * @Description: 通知公告 更多
 * @Author: PF
 * @Date: 2023-01-05 14:23:48
 * @LastEditors: PF
 * @LastEditTime: 2025-06-20 09:06:04
 * @FilePath: \ZHXY_VUE3.0\src\components\home\tongzhigonggao.vue
-->
<template>
  <div>
    <el-dialog class="wp70 hp80" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">通知公告</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-input placeholder="标题" v-model="dataGrid.parms.bt" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-cascader placeholder="发布机构" :options="jgTree" v-model="dataGrid.parms.fbjgid" :props="{ label: 'jgmc', value: 'id', children: 'children', checkStrictly: true}" :show-all-levels="false" clearable filterable @change="bindTable()"></el-cascader>
              </el-form-item>
              <el-form-item>
                <el-date-picker placeholder="发布日期" v-model="dataGrid.parms.fbsj" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" clearable @change="bindTable()"/>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="阅读状态" v-model="dataGrid.parms.sfdq" clearable filterable :teleported="false" @change="bindTable()">
                  <el-option label="已读" :value="true" />
                  <el-option label="未读" :value="false" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <el-tabs v-model="GongGaoActive" @tab-change="bindTable()">
              <el-tab-pane label="全部" :name="0"></el-tab-pane>
              <el-tab-pane label="学校" :name="1"></el-tab-pane>
              <el-tab-pane label="部门" :name="2"></el-tab-pane>
            </el-tabs>
            <!-- 按钮区域 BEGIN -->
              <el-button v-if="GongGaoActive==1 && xxData" type="primary" link style="position: absolute;right: 0;top: 10px;" @click="openXueXiao=true"><span class="el-icon--left iconfont icon-shezhi"></span>管理</el-button>
              <el-button v-if="GongGaoActive==2 && bmData.length" type="primary" link style="position: absolute;right: 0;top: 10px;" @click="openBuMen=true"><span class="el-icon--left iconfont icon-shezhi"></span>管理</el-button>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" show-overflow-tooltip :tooltip-options="{ placement: 'bottom' }" sortable v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bt" header-align="center" align="left" show-overflow-tooltip :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="isTZGGSEE=true; row=scope.row">[{{ scope.row.gglx == 2 ? scope.row.jgmc : scope.row.fbrmc}}] {{scope.row.bt}}</span>
                </template>
              </el-table-column>
              <el-table-column label="公告类型" prop="gglx" v-if="GongGaoActive===0" align="center">
                <template #default="scope">
                  <span v-if="scope.row.gglx == 1">学校通知</span>
                  <span v-if="scope.row.gglx == 2">部门通知</span>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" prop="fbsj" align="center" />
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xuexiaoguanli v-if="openXueXiao" v-model:openList="openXueXiao" @ReturnData="bindTable()" />
  <bumenguanli v-if="openBuMen" v-model:openList="openBuMen" @ReturnData="bindTable()" />
  <detail v-if="isTZGGSEE" v-model:openDetail="isTZGGSEE" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps } from 'vue'
import { loadList, closeWindow, loadSelect } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import xuexiaoguanli from './xuexiaoguanli.vue'
import bumenguanli from './bumenguanli.vue'
import detail from './detail.vue'

const props = defineProps({ openList: { type: Boolean, required: true } })
const emits = defineEmits(['update:openList', 'ReturnData'])

const GongGaoActive = ref(0)

const row = ref()
const openXueXiao = ref(false)
const openBuMen = ref(false)
const isTZGGSEE = ref(false)

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'fbsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.gglx = GongGaoActive.value || undefined
  dataGrid.value.parms.fbjgid = Array.isArray(dataGrid.value.parms.fbjgid)
    ? dataGrid.value.parms.fbjgid[dataGrid.value.parms.fbjgid.length - 1]
    : dataGrid.value.parms.fbjgid
  loadList({
    url: '/api/v2/bangong/tongzhigonggao/shouye/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      res.data.list.forEach(element => {
        const info = bmData.value.find(item => item.id === element.fbjgid)
        element.sffzr = !!info
      })
    }
  })
}
// 加载 部门 下拉框
const bmData = ref()
// 加载 学校 下拉框
const xxData = ref()
// 加载 发布机构 下拉框
const jgTree = ref([])
watch(
  () => props.openList,
  () => {
    if (props.openList) {
      GongGaoActive.value = 0
      loadSelect({ url: '/api/v2/bangong/tongzhigonggao/quanxian/shouye/bumentongzhi', data: bmData })
      loadSelect({ url: '/api/v2/bangong/tongzhigonggao/quanxian/shouye/xuexiaotongzhi', data: xxData })
      loadSelect({ url: '/api/v2/xiaoneijigou/tree', data: jgTree })
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
